export enum InterventionEventCapability {
  ACCEPTABLE,
  REJECTABLE,
  CANCELLABLE,
  UNLOCKABLE,
  MARKUP_AMENDABLE,
  PRICEABLE,
  CLEARABLE,
}

export namespace InterventionEventCapability {
  let elements = [
    InterventionEventCapability.ACCEPTABLE,
    InterventionEventCapability.REJECTABLE,
    InterventionEventCapability.CANCELLABLE,
    InterventionEventCapability.UNLOCKABLE,
    InterventionEventCapability.MARKUP_AMENDABLE,
    InterventionEventCapability.PRICEABLE,
    InterventionEventCapability.CLEARABLE,
  ];
  let alias = "com.bcdfx.model.InterventionEventCapability";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
